import { MissingKeyError } from '../errors';
import { converteValueToType } from '../util';
export class DomElementAccessor {
    constructor(data) {
        this.data = data;
    }
    value(path, type = 'string', defaultValue) {
        if (this.data.hasAttribute(path)) {
            const value = this.data.getAttribute(path);
            return converteValueToType(value, type);
        }
        else {
            if (arguments.length === 3) {
                return defaultValue;
            }
            throw new MissingKeyError(path);
        }
    }
    has(key) {
        return this.data.hasAttribute(key) || this.list(key, []).length > 0; // should we also check for elements ?
    }
    get(path, defaultValue) {
        const collection = this.data.getElementsByTagName(path);
        if (collection.length === 0) {
            if (arguments.length === 2) {
                return defaultValue;
            }
            throw new MissingKeyError(path);
        }
        return new DomElementAccessor(collection[0]);
    }
    list(path, defaultValue) {
        const elements = this.data.getElementsByTagName(path);
        if (elements.length === 0) {
            if (defaultValue === undefined) {
                throw new MissingKeyError(path);
            }
        }
        const result = [];
        for (let i = 0; i < elements.length; i++) {
            const item = elements.item(i);
            if (item === null) {
                continue;
            }
            result.push(new DomElementAccessor(item));
        }
        return result;
    }
}
